import * as React from 'react'
import Link from 'next/link'
import styled from 'styled-components'
import Button from '@app.components/Button'

const NewsCardListEmpty: React.FC = () => {
  return (
    <StyledWrapper>
      <div className="hr" />
      <div className="empty">
        <div className="empty-title">
          <span>스크랩한 채널소식</span>이 없습니다.
        </div>
        <div className="empty-subtitle">
          기업들의 최신 소식을 확인하시겠어요?
        </div>
        <Link href="/channel">
          <a>
            <Button className="btn" color="lightGrey">
              채널보기
            </Button>
          </a>
        </Link>
      </div>
    </StyledWrapper>
  )
}

export default NewsCardListEmpty

const StyledWrapper = styled.div`
  margin-bottom: 40px;
  .hr {
    height: 1px;
    background-color: #eeeeee;
  }
  .empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 0;
    gap: 10px;
    .empty-title {
      font-size: 20px;
      font-weight: 500;
      span {
        color: #01a0ff;
      }
    }
    .empty-subtitle {
      padding-bottom: 10px;
      font-size: 16px;
      font-weight: 500;
      color: #999999;
    }
    .btn {
      width: 82px;
      height: 38px;
    }
  }
`
